import { AfterContentInit, Component, Input, ViewChild } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ISelectInput } from '../../box/interfaces/select-input.interface';
import { FILTER_CONTENT_ITEM } from '../../content/token';
import { BaseFilter } from '../base-filter';
import { FilterAutoCompleteInputComponent } from '../../autocomplete/search-autocomplete-input.component';

@Component({
  selector: 'portal-one-selection-filter',
  templateUrl: './one-selection-filter.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: OneSelectionFilterComponent,
    },
  ],
  standalone: false,
})
export class OneSelectionFilterComponent extends BaseFilter implements AfterContentInit {
  @Input() entitiesAdded$ = new BehaviorSubject<ISelectInput[]>(null);
  @ViewChild(FilterAutoCompleteInputComponent) searchInput!: FilterAutoCompleteInputComponent;
  constructor() {
    super();
  }
  ngAfterContentInit(): void {
    if (this.entitiesAdded$) {
      this.entitiesAdded$.subscribe((entities) => {
        if (entities) {
          this.mapRetainedEntities(entities);
        }
      });
    }
  }
  mapRetainedEntities(selectors): void {
    if (selectors[this.selector]) {
      selectors[this.selector].forEach((element) => {
        this.onEntityAdded(element);
      });
      this.updateEntities();
    }
  }

  onEntityAdded(selectedEntity: ISelectInput): void {
    this.localPreSelectedEntities.clear();
    this.localPreSelectedEntities.set(selectedEntity.id, selectedEntity);
  }
}
